export const LOADING_FACTOR = "LOADING_FACTOR";
export const SAVE_LOADING_FACTOR = "SAVE_LOADING_FACTOR";
export const GET_FACTOR = "GET_FACTOR";
export const FORM_FAIL = "FORM_FAIL";
export const FACTOR_FAIL = "FACTOR_FAIL";
export const LOADING_FACTOR_BY_ID = "LOADING_FACTOR_BY_ID";
export const GET_FACTOR_BY_ID = "GET_FACTOR_BY_ID";

